<template>
  <div>
    <b-modal size="lg" id="billing_modal" title="Setup billing" centered hide-footer>
      <div class="mx-3 my-3">
        <b-form-group label="Enter your card" description="For other payment methods contact us">
          <card ref="stripe_card_ele" class='form-control mb-3' :options='stripe_options' :stripe='config.stripe.public_key' @change='complete = $event.complete' />
        </b-form-group>

        <b-form-group class="mt-3">
          <LoadingButton variant="primary" id="add_card" class='pay-with-stripe' @click='add_card' :loading='adding_card'>Add card</LoadingButton>
        </b-form-group>
      </div>
    </b-modal>

    <div v-if="!modal_only">
      <div v-if="profile.payment_method">
        <p>Using card ending in {{profile.payment_method}}. Contact us to change payment method.</p>
      </div>
      <div v-else>
        <b-button variant="primary" @click="setup_billing">{{button_text}}</b-button>
      </div>
    </div>
  </div>
</template>

<script>

import {Card, instance} from 'vue-stripe-elements-plus'
import api from '@/lib/api'

export default {
  name: 'SelectCard',
  props: {
    profile: {type: Object, required: true},
    modal_only: {type: Boolean, required: false},
    action: {type: Function, required: false},
    button_text: {default: 'Add Card'}
  },
  components: {Card},
  data () {
    return {
      adding_card: false,
      complete: false,
      stripe_options: {
        hidePostalCode: false
      },
      setupintent: undefined
    }
  },
  methods: {
    setup_billing () {
      this.$bvModal.show('billing_modal')
      this.adding_card = false
      this.setupintent = api.stripe_request_setupintent()
    },
    async add_card () {
      this.adding_card = true
      this.$swal('Please wait', 'This can take up to 30 seconds to complete', 'info')

      var response = await this.setupintent

      var options = {
        'payment_method_data': {
          'billing_details': {
            'email': this.profile.email
          }
        }
      }

      response = await instance.handleCardSetup(response.data.client_secret, this.$refs.stripe_card_ele.$refs.element._element, options)
      if (response.error) {
        console.warn(response.error)
        this.$swal('Error', response.error.message, 'error')
        this.adding_card = false
        return
      } else if (response.data && response.data.raw) {
        console.warn(response.data.raw)
        this.$swal('Error', response.data.raw.message, 'error')
        this.adding_card = false
        return
      }
      response = await api.stripe_add_card(response.setupIntent.payment_method, this.tax_id, this.tax_type)
      if (response.error) {
        console.warn(response.error)
        this.$swal('Error', response.error.message, 'error')
        this.adding_card = false
        return
      } else if (response.data && response.data.raw) {
        console.warn(response.data.raw)
        this.$swal('Error', response.data.raw.message, 'error')
        this.adding_card = false
        return
      } else if (response.data && response.data.error) {
        console.warn(response.data.error)
        this.$swal('Error', response.data.error.message, 'error')
        this.adding_card = false
        return
      }
      this.$bvModal.hide('billing_modal')
      this.adding_card = false

      if (this.action) {
        this.action()
      }

      this.$swal.close()
    }
  }
}
</script>

<style scoped>

</style>
